import { useState } from 'react';
import { shouldUseNewShell } from '../lib/newShell';

/**
 * Whether this page load shows the new mobile shell. Decided once: the
 * wrapper and the flag do not change while the page is open, and flipping
 * shells under a member mid-task would lose what they were doing.
 */
export const useNewShell = (): boolean => useState(shouldUseNewShell)[0];
